import { Suspense, useEffect, useRef, useState } from "react";
import SwalAlert from "../../../../../services/swalService/SwalService";
import { useAddEmployeesByCorporateMemberIdMutation, useCheckGMAPCertificationByEmailMutation } from "../../../../../app/services/Employees/employeeApi";
import CenterModel from "../../../../../components/ui/centerModel/CenterModel";
import DataLoader from "../../../../../components/ui/dataLoader/DataLoader";
import FormCreator from "../../../../../components/Forms/FormCreator";
import Buttons from "../../../../../components/ui/button/Buttons";
import ToastService from "../../../../../services/toastService/ToastService";
import { NewEmployeeFormData } from "../data/NewEmployeeData";

const AddEmployee = ({ show, setShow, id, closeModal }) => {
  const addEmployeeRef = useRef();
  const { error, success } = SwalAlert();
  const [formdata, setFormdata] = useState(NewEmployeeFormData);
  const phoneFieldMap = {contactNumberId: "contactNumber",};
  const [AddEmployeesByCorporateMemberId, { isSuccess: addEmployeeIsSuccess, isLoading: addEmployeeIsLoading, data: addEmployeeData, },] = useAddEmployeesByCorporateMemberIdMutation();
  const [checkGMAPCertificationByEmail, { isSuccess: checkCertificationIsSuccess, isLoading: checkCertificationIsLoading, data: checkCertificationData, },] = useCheckGMAPCertificationByEmailMutation();

  const handleModalClose = () => {
    closeModal();
    handleClear();
  }

 const handleClear = () => {
    closeModal();
    const updatedForm = { ...NewEmployeeFormData };
    setFormdata(updatedForm);
  };

  const handleFormFieldChange = (dataField, value) => {
    let form = { ...formdata };
    form.initialState = { ...form.initialState };
    if (["contactNumber"].includes(dataField)) {
      const updatedInitialState = { ...form.initialState, [dataField]: value.replace(/\D/g, "") }
      setFormdata((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
    }
    else if (Object.keys(phoneFieldMap).includes(dataField)) {
      const relatedInput = phoneFieldMap[dataField];
     // let updatedMaxLength = value?.value == 153 ? 8 : 25;
      const updatedFormFields = form.formFields.map((field) => {
        if (field.id === relatedInput) {
          return { ...field, fieldSetting: { ...field.fieldSetting,}, };
        }
        return field;
      });
      const updatedInitialState = { ...form.initialState, [dataField]: value?.value, };
      setFormdata((prev) => ({ ...prev, formFields: updatedFormFields, initialState: { ...prev.initialState, ...updatedInitialState, }, }));
    }
    else {
      // update field value safely
      setFormdata((prev) => ({ ...prev, ...form, initialState: { ...prev.initialState, ...form.initialState, [dataField]: value, }, }));
    }
  }

  const handleAddEmployee = () => {
    const formDetails = addEmployeeRef?.current?.getFormData();
    if (!formDetails) {
      error("Please fill in all mandatory fields to continue.", "");
      return
    }
    let req = {
      sGBCCorporateMemberId: id,
      salutationId: formDetails?.salutationId?.value || formDetails?.salutationId,
      firstName: formDetails?.firstName,
      lastName: formDetails?.lastName,
      email: formDetails?.email,
      gMPCertification: formDetails?.gmpCertification || "",
      contactnumberCountryId: formDetails?.contactNumberId?.value || formDetails?.contactNumberId,
      contactNumber: formDetails?.contactNumber,
      designation: formDetails?.designation,
      jobLevelId: formDetails?.jobLevelId?.value || formDetails?.jobLevelId,
      jobFunctionId: formDetails?.jobFunctionId?.value || formDetails?.jobFunctionId,
      isUpcomingEvents: formDetails?.isUpcomingEvent || false,
      isMonthlyBulletin: formDetails?.isMonthlyBulletin || false,
      isBeSectorUpdates: formDetails?.isSectorUpdate || false,
    }
    AddEmployeesByCorporateMemberId(req)
  }
  
useEffect(() => {
    if (!addEmployeeIsLoading && addEmployeeIsSuccess && addEmployeeData) {
      if ( addEmployeeData?.errorMessage === "Employee already exists" ) {
        error( "Employee already exists", "Failed" );
        handleClear();
        return;
      }
      success("Employee has been added successfully.", "Successful");
      handleClear();
    }
  }, [addEmployeeIsLoading, addEmployeeIsSuccess, addEmployeeData,]);


useEffect(() => {
  if ( !checkCertificationIsLoading && checkCertificationIsSuccess && checkCertificationData) {
    setFormdata((prev) => ({
      ...prev,
      initialState: {
        ...prev.initialState,
        searchEmailAddress: prev.initialState.searchEmailAddress,
        email: prev.initialState.searchEmailAddress,
        salutationId: checkCertificationData?.salutationId ?? null,
        firstName: checkCertificationData?.firstName ?? "",
        lastName: checkCertificationData?.lastName ?? "",
        designation: checkCertificationData?.designation ?? "",
        jobLevelId: checkCertificationData?.jobLevelId ?? null,
        jobFunctionId: checkCertificationData?.jobFunctionId ?? null,
        contactNumberId: checkCertificationData?.contactNumberCountryId ?? null,
        contactNumber: checkCertificationData?.contactNumber ?? "",
        isUpcomingEvent: checkCertificationData?.isUpcomingEvents ?? true,
        isMonthlyBulletin:checkCertificationData?.isMonthlyBulletin ?? true,
        isSectorUpdate:checkCertificationData?.isBESectorUpdates ?? true,
      },

      formFields: prev.formFields.map((field) => {
        if (field.id === "gmpCertification") {
          return {
            ...field,
            fieldSetting: {
              ...field.fieldSetting,
              formTitle: `GMP Certification : ${
                checkCertificationData?.applicationType || "-"
              }`,
            },
          };
        }

        if (["isUpcomingEvent", "isMonthlyBulletin", "isSectorUpdate", ].includes(field.id)) {
          return {
            ...field,
            fieldSetting: {
              ...field.fieldSetting,
              isDisable: false,
            },
          };
        }

        if (field.id === "email") {
          return {
            ...field,
            fieldSetting: {
              ...field.fieldSetting,
              isDisable: true,
            },
          };
        }

        return {
          ...field,
          fieldSetting: {
            ...field.fieldSetting,
            isDisable: false,
          },
        };
      }),
    }));
  }
}, [checkCertificationIsLoading, checkCertificationIsSuccess, checkCertificationData,]);


  const formActionHandler = {
    CLEAR: handleClear,
  };

    const handleEmailSearch = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let email = addEmployeeRef?.current?.getFieldValue( "searchEmailAddress" );
    let isEmail = emailRegex.test( email );
    if ( isEmail ) {
      let request = {
        EmailAddress: email
      }
      if ( id > 0 ) {
        checkGMAPCertificationByEmail( request )
      }
    }
  }
    useEffect(() => {
        setFormdata((prev) => {
            if (!prev?.formFields) return prev;
            return {
                ...prev,
                formFields: prev.formFields.map((field) => {
                    if (field.id === "searchEmailButton") {
                        return {
                            ...field,
                            additionalComponent: (
                                <Buttons
                                    onClick={handleEmailSearch}
                                    buttonText="Search"
                                    buttonTypeClassName="success-btn d-block"
                                    isLoading={checkCertificationIsLoading}
                                    isDisable={checkCertificationIsLoading}
                                />
                            ),
                        };
                    }
                    return field;
                }),
            };
        });
    }, [checkCertificationIsLoading]);

   useEffect(() => {
    if (!show) return;

    setFormdata((prev) => ({
      ...prev,
      formFields: prev.formFields.map((field) => ({
        ...field,
        fieldSetting: {
          ...field.fieldSetting,
          isDisable: field.id !== "searchEmailAddress",
        },
      })),
    }));
  }, [show]);

  return (
    <div>
      <CenterModel
        modelTitle={"New Employee"}
        show={show}
        className="new-employee-model"
        handleClose={() => handleModalClose()}
      >
        <div className="row">
          <Suspense fallback={<DataLoader />}>
            <FormCreator
              ref={addEmployeeRef}
              {...formdata}
              onActionChange={formActionHandler}
              onFormFieldValueChange={handleFormFieldChange}
            />
          </Suspense>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Buttons
            className="center-btn mt-4"
            buttonText="Submit"
            buttonTypeClassName="success-btn"
            isLoading={addEmployeeIsLoading}
            isDisable={addEmployeeIsLoading}
            onClick={() => handleAddEmployee()}
          />
        </div>
      </CenterModel>
    </div>
  )
}

export default AddEmployee
